var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn is-ghost align-top",on:{"click":this.export}},[_vm._v("\n    Export sales round\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }